import axios from 'axios'

import { APP_PLATFORM, LOCAL_STORAGE } from './constants'
import { refreshBundle, errorInterceptorHandler, generateId } from './utils/utils'

/// [NS] NOTE FOR DEVELOPERS MODIFYING THIS: THE INTERCEPTOR CATCHING THE RESP AND THEN JUST RETURNING DATA BREAKS TYPESCRIPT BECAUSE IT IS EXPECTING AN AXIOS RESPONSE.
// [NS] I MADE V2 WHICH RETURNS THE ACTUAL RESPONSE NEEDED FOR TYPE SAFETY. IF YOU ARE CONVERTING A FILE AND GET TYPE ERRORS YOU CAN UPDATE THE ENDPOINT TO USE VS

export const axiosBackendInstance = axios.create({
  baseURL: `${process.env.REACT_APP_SERVER_URL}`,
  timeout: 25000,
  withCredentials: true,
})

axiosBackendInstance.interceptors.request.use(async (config) => {
  const token = localStorage.getItem(LOCAL_STORAGE.JWT_TOKEN)
  await refreshBundle()
  if (token) {
    config.headers.authorization = `Bearer ${token}`
  }

  // Add other headers
  config.headers['x-platform'] = window.ReactNativeWebView
    ? APP_PLATFORM.NATIVE_APP
    : APP_PLATFORM.WEB
  config.headers['x-request-id'] = generateId(12)

  return config
})

axiosBackendInstance.interceptors.response.use((response) => response.data, errorInterceptorHandler)

// This wrapper to respo with the data is killing our TypeScript. Updating this to return the full response object
export const axiosBackendInstanceV2 = axios.create({
  baseURL: `${process.env.REACT_APP_SERVER_URL}`,
  timeout: 25000,
  withCredentials: true,
})

axiosBackendInstanceV2.interceptors.request.use(async (config) => {
  const token = localStorage.getItem(LOCAL_STORAGE.JWT_TOKEN)
  await refreshBundle()
  if (token) {
    config.headers.authorization = `Bearer ${token}`
  }

  // Add other headers
  config.headers['x-platform'] = window.ReactNativeWebView
    ? APP_PLATFORM.NATIVE_APP
    : APP_PLATFORM.WEB
  config.headers['x-request-id'] = generateId(12)

  return config
})

axiosBackendInstanceV2.interceptors.response.use((response) => response, errorInterceptorHandler)
